import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";

/*
 * @Author       : zhangying@xdf.cn
 * @Date         : 2021-11-03 15:44:45
 * @LastEditors  : zhangying@xdf.cn
 * @LastEditTime : 2022-03-28 15:01:18
 * @Description  : 描述信息
 */
import { getBoxPageList } from '@/api/modules/pageCode.js';
export var getCodeUrlMixins = {
  data: function data() {
    return {
      baseUrl: '',
      env: ''
    };
  },
  created: function created() {
    this.getBaseApi();
  },
  methods: {
    getBaseApi: function getBaseApi() {
      var env = process.env.VUE_APP_TARGET;
      this.env = env;
      var OPTION_MAP = {
        online: "https://".concat(location.host, "/tcscreen"),
        pre: "https://".concat(location.host, "/tcscreen"),
        test: "https://".concat(location.host, "/tcscreen/").concat(env)
      };
      this.baseUrl = ['online', 'pre'].includes(env) ? OPTION_MAP[env] : OPTION_MAP.test;
    },
    getCodeTurn: function getCodeTurn(params) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obtainMethod, _yield$getBoxPageList, resData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                obtainMethod = params.obtainMethod;
                delete params.obtainMethod;
                _context.next = 4;
                return getBoxPageList(params);

              case 4:
                _yield$getBoxPageList = _context.sent;
                resData = _yield$getBoxPageList.data;

                if (!(resData.result === null)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  result: null
                });

              case 8:
                return _context.abrupt("return", {
                  result: _objectSpread({
                    page: resData.page,
                    obtainMethod: obtainMethod
                  }, resData.result)
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};